(() => {

  async function getCart() {
    const res = await fetch('/cart.js');
    return await res.json();
  }

  function initRingGuide() {
    const t = window.ringGuideLocale || {};
    const accordion = document.querySelector('.ring-accordion');
    if (!accordion) return;

    const trigger = accordion.querySelector('.ring-accordion__trigger');
    const atcButton = accordion.querySelector('.ring-accordion__atc');

    if (!atcButton) return;

    const variantId = Number(atcButton.dataset.variantId);

    if (!accordion.dataset.bound) {
      accordion.dataset.bound = "true";

      if (trigger) {
        trigger.addEventListener('click', () => {
          accordion.classList.toggle('open');
        });
      }

      atcButton.addEventListener('click', async function () {

        const variantId = Number(this.dataset.variantId);
        if (!variantId) return;

        try {
          this.disabled = true;
          this.textContent = t.adding || "Adding...";

          const response = await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
              'Content-Type': 'application/json',
              'Accept': 'application/json'
            },
            body: JSON.stringify({
              id: variantId,
              quantity: 1
            })
          });

          if (!response.ok) throw new Error('Cart error');

          await response.json();

          this.textContent = t.added || "Added";

          window.location.reload();

        } catch (err) {
          console.error(err);
          this.textContent = t.error || "Error, Try again";
          this.disabled = false;
        }
      });
    }

    // CART CHECK
    getCart().then(cart => {
      const exists = cart.items.some(item => item.variant_id === variantId);

      if (exists) {
        atcButton.disabled = true;
        atcButton.textContent = t.added || "Already in cart";
        atcButton.classList.add('is-disabled');
      }
    });
  }

  initRingGuide();

  document.addEventListener('shopify:section:load', initRingGuide);

})();